import { format, DATE_TIME_FORMATS, parseISO } from '@white-label-helper/date-utilities';
import type { FlightInfo } from '@white-label-types/search-box'
import type { TerminalFlight } from '@white-label-types/terminal-flight'

export function extractFlights(terminalFlights: Array<TerminalFlight>, onlyFutureFlights: boolean = true): Array<FlightInfo>
{
  const flights: Array<FlightInfo> = [];
  const now = new Date();

  // Order flights in chronological order
  terminalFlights.sort(function(a, b) {
    return (parseISO(a.inventory_item.scheduleTime).getTime() - parseISO(b.inventory_item.scheduleTime).getTime());
  })

  terminalFlights.forEach((item) => {
    const flightDateTime = parseISO(item.inventory_item.scheduleTime);

    if(onlyFutureFlights && now > flightDateTime) {
      return;
    }

    const terminalQueue = item.inventory_item.operationalAreas?.[0]?.eligibleQueues?.[0];
    const eligibleQueues: FlightInfo['eligibleQueues'] = terminalQueue ? {
      slotClosing: terminalQueue.slotClosing,
      slotOpening: terminalQueue.slotOpening,
      providerProductCode: terminalQueue.processingPointId,
    } : undefined;

    flights.push({
      id: String(item.search_product_result_id),
      airline: item.inventory_item.country,
      terminal: item.inventory_item.terminal,
      time: format(flightDateTime, DATE_TIME_FORMATS.time_24hr),
      date: format(flightDateTime, DATE_TIME_FORMATS.month_day),
      airport: `MAN -> ${item.inventory_item.destinationIATA}`,
      flightNumber: item.inventory_item.airlineIATA + item.inventory_item.flightNumber,
      flightDetails: {
        flightNumber: item.inventory_item.flightNumber,
        airlineIATA: item.inventory_item.airlineIATA,
        airlineICAO: item.inventory_item.airlineICAO,
        scheduleTime: item.inventory_item.scheduleTime,
      },
      eligibleQueues,
    });
  });

  return flights;

}
